import React, { createRef } from 'react';
import MenuComponent from './components/menu/Menu';
import './AnimationTool.scss';
import { SplitPane } from 'react-multi-split-pane';

import PerfectScrollbar from 'react-perfect-scrollbar';
// Estilos
import 'react-perfect-scrollbar/dist/css/styles.css';
import ImgList from './components/imgList/ImgList';
import AnimationList from './components/animationList/AnimationList';
import KeyTools from './components/keyTools/KeyTools';
import FramesKeyControls from './components/framesKeyControls/FramesKeyControls';
import { Frames } from './components/frames/Frames';
import RenderAnimation from './components/renderAnimation/RenderAnimation';

import ImportAtlasForm from './components/modals/ImportAtlasForm';
import ContextMenu from './components/contextMenu/ContextMenu';
import store from '../../Redux/Store/store';
import { CloseSideContextMenuAction } from '../../Redux/Actions/Atlas/contextSideMenu.action';
import { ResetAllAnimationAction } from '../../Redux/Actions/globals.actions';
import { connect } from 'react-redux';
import ToastNotificationAnimation from './components/notifications/ToastNotificationAnimation';
import { ObserverAnim } from './Observer';
import ExportButton from './components/exportButtons/ExportButton';
import PatreonModal from '../AtlasPacker/components/modals/patreonModal/PatreonModal';

const _scrollBarRef = createRef<any>();

class AnimationTool extends React.Component<{ CloseSideContextMenuAction: any, ResetAllAnimationAction: () => {} }> {

    constructor(props: { CloseSideContextMenuAction: any, ResetAllAnimationAction: () => {} }) {
        super(props);

        this.handleClickContainerAtlas = this.handleClickContainerAtlas.bind(this);
    }

    UNSAFE_componentWillMount() {
        ObserverAnim.removeAllListeners();
        this.props.ResetAllAnimationAction();
    }

    handleClickContainerAtlas() {
        if (store.getState().contextSideMenuAtlas.active) {
            this.props.CloseSideContextMenuAction();
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="principal-anim-container"
                    onContextMenu={(event) => event.preventDefault()}
                    onClickCapture={this.handleClickContainerAtlas}
                    onDrop={e => e.preventDefault()}
                    onDragOver={e => e.preventDefault()}
                >
                    <MenuComponent />
                    <SplitPane split="vertical" className="panels-anim-container" defaultSizes={[20, 60, 20]} minSize={[200, 500, 200]}
                    // onDragFinished={() => Observer.emit(GLOBAL_EVENT.PANEL_RESIZE_END)}
                    >
                        <div className="left-anim-panel">
                            <div className="left-anim-panel-image--container">
                                <PerfectScrollbar options={{ suppressScrollX: true }} ref={_scrollBarRef} className="perfect_scroll_imglist">
                                    <ImgList />
                                </PerfectScrollbar>
                            </div>
                        </div>

                        <div className="center-anim-panel">
                            <div className="center-anim-panel--up" id="center-anim-panel--up">
                                <RenderAnimation />
                            </div>
                            <div className="center-anim-panel--down">
                                <KeyTools />
                                <div className="frames-section--container d-flex justify-content-between align-items-center">
                                    <div className="frames-section">
                                        <Frames />
                                    </div>
                                    <div className="frames-key-control pl-2 mr-2">
                                        <FramesKeyControls />
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="right-anim-panel">
                            <div className="right-anim-panel--up">
                                <div className="right-anim-panel-animationList--container">
                                    <PerfectScrollbar options={{ suppressScrollX: true }} ref={_scrollBarRef}>
                                        <AnimationList />
                                    </PerfectScrollbar>
                                </div>
                            </div>
                            <div className="right-anim-panel--down">
                                <ExportButton title="Save animation" handleClick={() => {
                                    alert('Exorta carallo');
                                }} />
                            </div>
                        </div>
                    </SplitPane>
                    <ContextMenu onUpdateSize={() => { }} />
                </div>
                <ImportAtlasForm />
                <ToastNotificationAnimation />
                <PatreonModal />
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    ResetAllAnimationAction,
    CloseSideContextMenuAction
}

export default connect(null, mapDispatchToProps)(AnimationTool);